import {getBootstrapData} from '@ui/bootstrap-data/bootstrap-data-store';
import {Video} from '@app/titles/models/video';
import {activeLocale} from '@app/i18n/localize-link';
import {localizeUrl} from '@app/i18n/localize-url';
import {DEFAULT_LOCALE, isAppLocale, type AppLocale} from '@app/i18n/locale-config';

/**
 * P6 — İzleme (watch) sayfası URL'i artık LOCALE-DOĞRU.
 *
 * Kök sebep: eskiden watch URL her zaman prefix'siz `/izle/{id}` idi (oynatıcı
 * "kanonik prefix'siz" kabul ediliyordu, K1). Bu yüzden hedef-dilli bir video
 * (ör. video.locale='es') tıklandığında Türkçe siteye (/izle/{id}) düşüyordu.
 *
 * Yeni davranış: URL, videonun HEDEF diline (video.locale) göre localize edilir;
 * video.locale boşsa aktif site locale'ine düşer. TR (varsayılan) → prefix'siz
 * `/izle/{id}` (byte-identical, sıfır regresyon). Non-TR → `/es/ver/{id}`,
 * `/en/watch/{id}`, `/ar/mushahada/{id}`, `/ru/smotret/{id}` (segment çevirisi
 * localizeUrl + route-translations sözlüğünden gelir). Watch sayfaları
 * noindex,follow olduğu için locale-prefix'li varyant SEO duplicate riski taşımaz.
 */
function resolveWatchLocale(video: Video): AppLocale {
  const vloc = (video.locale ?? '').trim();
  if (isAppLocale(vloc)) return vloc as AppLocale;
  return activeLocale();
}

export function getWatchLink(
  video: Video,
  {absolute}: {absolute?: boolean} = {},
): string {
  const locale = resolveWatchLocale(video);
  // TR (varsayılan): mevcut kanonik prefix'siz URL — regresyon yok.
  // Non-TR: /tr/izle/{id}'yi hedef dile çevir → /es/ver/{id} vb.
  let link =
    locale === DEFAULT_LOCALE
      ? `/izle/${video.id}`
      : localizeUrl(`/tr/izle/${video.id}`, locale);
  if (absolute) {
    link = `${getBootstrapData().settings.base_url}${link}`;
  }
  return link;
}
